import PropTypes from 'prop-types';

export const states = Object.freeze({
  idle: 'idle',
  loading: 'loading',
  success: 'success',
  error: 'error',
});

export const stateHelper = Object.freeze({
  isIdle: (state) => state === states.idle,
  isLoading: (state) => state === states.loading,
  isError: (state) => state === states.error,
  isSuccess: (state) => state === states.success,
});

export const getState = ({ idle, loading, error }) => {
  if (Boolean(idle)) {
    return states.idle;
  }
  if (Boolean(loading)) {
    return states.loading;
  }
  if (Boolean(error)) {
    return states.error;
  }
  return states.success;
};

export const StatePropType = PropTypes.oneOf(Object.keys(states));
